export default "__VITE_ASSET__8d0f2e93__"